import { AnalyzerLandingScreen } from "@/screens/prequal/AnalyzerLandingScreen"

export default function AnalyzerLandingPage() {
  return <AnalyzerLandingScreen />
}
